import type React from 'react';

import type { Errors } from './MultiDatePicker';

import { CalendarArrowIcon } from '../../icons';

import * as styles from '../util/styles';
import { DateInput } from '../../Input/DateInput';

enum Input {
  Start = 0,
  End = 1,
}

export enum InputFocus {
  StartDate = 'Start',
  EndDate = 'End',
  None = 'None',
}

export interface DatePickerNavBarProps {
  startDateInputValue?: string;
  endDateInputValue?: string;

  handleInputChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleInputFocus: (focus: InputFocus) => void;
  showErrorMessage?: boolean;
  errors?: Errors;

  setStartInput?: (input?: HTMLElement) => void;
  setEndInput?: (input?: HTMLElement) => void;

  dataTest?: string;

  isDayPickerOpen?: boolean;
  focusable?: boolean;
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const MultiDatePickerNavbar: React.FC<DatePickerNavBarProps> = ({
  startDateInputValue,
  endDateInputValue,
  handleInputChange,
  handleInputFocus,
  showErrorMessage = true,
  errors,
  setStartInput,
  setEndInput,
  isDayPickerOpen,
  dataTest,
  focusable = true,
}) => {
  const inputCSSClasses = (inputType: Input): string => {
    if (!focusable) {
      return `${styles.input} ${styles.removeInputFocusStyles}`;
    }

    if (inputType === Input.Start && errors && errors.start) {
      return `${styles.input} ${styles.inputError}`;
    }

    if (inputType === Input.End && errors && errors.end) {
      return `${styles.input} ${styles.inputError}`;
    }

    if (inputType === Input.End && errors && !errors.end && errors.range) {
      return `${styles.input} ${styles.inputError}`;
    }

    return styles.input;
  };

  const hasErrorOnFirstInput = errors?.start;

  return (
    <div className={styles.navbar}>
      <div className={styles.inputErrorWrapper(isDayPickerOpen, hasErrorOnFirstInput)}>
        <DateInput
          className={inputCSSClasses(Input.Start)}
          error={hasErrorOnFirstInput}
          placeholder='De:'
          value={startDateInputValue}
          onChange={handleInputChange}
          inputRef={setStartInput}
          onFocus={() => handleInputFocus(InputFocus.StartDate)}
          data-test={dataTest}
        />
        {/* Renders startDate error span if has error */}
        {errors?.start && showErrorMessage && <span className={styles.inputErrorLabel}>Insira uma data de início válida</span>}
      </div>
      <CalendarArrowIcon className={styles.navbarLogo} />
      <div className={styles.inputErrorWrapper(isDayPickerOpen, hasErrorOnFirstInput)}>
        <DateInput
          className={inputCSSClasses(Input.End)}
          error={errors && (errors.end || errors.range)}
          placeholder='Para:'
          value={endDateInputValue}
          onChange={handleInputChange}
          inputRef={setEndInput}
          onFocus={() => handleInputFocus(InputFocus.EndDate)}
        />
        {/* Renders endDate error span if has error */}
        {errors?.end && showErrorMessage && <span className={styles.inputErrorLabel}>Insira uma data de fim válida</span>}
      </div>
    </div>
  );
};
